// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "sPlant_SalesOrder_Approve"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "type_code",
      label: "类别",
      sortable: true,
      formatter: (value, key, item) => {
        return value == "credit" ? "信用额度" : "价格不一致"
      }
    },
    {
      key: "CustAccount",
      label: "客户帐户",
      sortable: true
    },
    {
      key: "SalesName",
      label: "客户名称",
      sortable: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "SalesId",
      label: "销售订单编号",
      sortable: true
    },
    {
      key: "salesorder_amount",
      label: "销售订单金额",
      sortable: true,
      type: "number"
    },
    {
      key: "valid_credit",
      label: "剩余信用额度",
      sortable: true,
      type: "number"
    },
    {
      key: "SalesPrice",
      label: "价格",
      sortable: true,
      type: "number"
    },
    {
      key: "DiscPrice",
      label: "协议价格",
      sortable: true,
      type: "number"
    },
    {
      key: "create_by",
      label: "提交人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.create_by_username
      }
    },
    {
      key: "create_at",
      label: "提交时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "approved_by",
      label: "审批人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.approved_by_username
      }
    },
    {
      key: "approved_at",
      label: "审批时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "is_deleted",
      label: "删除",
      type: "boolean"
    },
    {
      key: "deleted_by",
      label: "删除人",
      formatter: (value, key, item) => {
        return item.deleted_by_username
      }
    },
    {
      key: "deleted_at",
      label: "删除时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "is_approved",
      label: "审批状态",
      type: "boolean"
    }
  ]
}

const dataForm = {}

///前端验证
const rules = {}

const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const methods = {
  ///获取审批数据
  async getData(_params) {
    let _fields = _.map(fields.default, "key")
    _fields.push("SalesTable_id")
    _fields.push("SalesLine_id")
    _fields.push("SalesLine_LineNum")
    _fields.push("ItemId")
    _fields.push("NameAlias")
    _fields.push("SalesQty")
    _fields.push("CurrencyCode")
    _fields.push("CommonRemark")
    _fields.push("VariantName")

    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _fields
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///特批通过
  async approveData(items, username, _update_status_list) {
    let _actions = []
    let so_biz_data = new biz_data_helper.base_entity_helper(
      "SalesTable",
      {},
      {}
    )
    const update_status_biz_data = new biz_data_helper.base_entity_helper(
      "update_approve_status",
      {},
      {}
    )

    _.each(items, t => {
      let _status = _.find(_update_status_list, { ItemId: t.id })
      if (_status) {
        _actions.push(
          update_status_biz_data
            .execAction({
              params: {
                IsApproved: t.is_so_approved == true ? 1 : 0,
                ApproveBy: username,
                status_id: _status.id
              },
              fields: ["is_update_ok"]
            })
            .action({
              output_last_item_map: {
                is_update_ok: "is_update_ok"
              }
            })
        )
      }
      if (t.type_code == "credit") {
        _actions.push(
          so_biz_data
            .updateAction({
              params: {
                id: t.id,
                approved_comment: t.approved_comment
              },
              fields: ["id"]
            })
            .action({ rollback_when: { is_update_ok: { "=": 1 } } })
        )
      }

    })
    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let _is_ok = true
      let _result_filter = _.filter(result.data.BatchResult.Actions, {
        Code: "data/u/SalesTable"
      })
      if (_result_filter && _result_filter.length > 0) {
        _.each(_result_filter, t => {
          _is_ok = !t.Result.Rollback
        })
      }

      return _is_ok
    } else {
      return false
    }
  },
  ///del ap
  async deleteData(items) {
    let _actions = []
    _.each(items, t => {
      _actions.push(
        biz_data
          .deleteAction({
            params: {
              id: t.id
            }
          })
          .action({})
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data
    ) {
      return true
    } else {
      return false
    }
  },
  async updateData(items) {
    let soa_biz_data = new biz_data_helper.base_entity_helper(
      "update_salesorder_esp",
      {},
      {}
    )
    let _actions = []
    _.each(items, t => {
      _actions.push(
        soa_biz_data
          .execAction({
            params: t
          })
          .action({})
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data
    ) {
      return true
    } else {
      return false
    }
  }
}
export { biz_data, dataForm, fields, methods, rules };

